(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Home",
            {
                url: "",
                component: "home"
            });
    }]);
    app.component("home",
        {
            templateUrl: "/App/States/Home/Home-template.html",
            controller: homeController
        });

    homeController.$inject = ["eventDays", "speakerList", "locationList"];
    function homeController(eventDays, speakerList, locationList) {
        var $ctrl = this;    

        $ctrl.changeCurrentDay = function (day) {
            $ctrl.currentDay = day;
        };

        $ctrl.toggleMobileNav = function () {
            $ctrl.navIsOpen = !$ctrl.navIsOpen;
        };

        $ctrl.$onInit = function(){
            $ctrl.eventDays = eventDays;
            $ctrl.currentDay = $ctrl.eventDays[0];
            $ctrl.speakerList = speakerList;
            $ctrl.locationList = locationList;
            $ctrl.navIsOpen = false;
        };
    }

})(window.app, window.angular); //jshint ignore:line

